/* Keep the availability label aligned with the selected variant. */
(() => {
 document.querySelectorAll('script[data-ds-availability-map]').forEach(source => {
  if (source.dataset.dsBound) return;
  source.dataset.dsBound = '1';
  const productId = source.dataset.dsAvailabilityMap;
  const states = JSON.parse(source.textContent);
  const section = source.closest('[id^="shopify-section-"]') || document;
  const update = () => {
   const input = section.querySelector('form[action*="/cart/add"] [name="id"]');
   const state = input && states[String(input.value)];
   if (!state) return;
   section.querySelectorAll('[data-ds-product-availability="' + productId + '"], [data-ds-selected-availability="' + productId + '"]').forEach(label => {
    if (label.textContent.trim() !== state.label) label.textContent = state.label;
    if (label.hasAttribute('data-ds-product-availability')) {
     const classes = 'badge ds-stock-badge ds-stock-badge--' + state.state;
     if (label.className !== classes) label.className = classes;
    }
   });
  };
  let frame;
  const queue = () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); };
  section.addEventListener('change', () => { queue(); setTimeout(queue,100); setTimeout(queue,500); });
  section.addEventListener('variant:change',queue);
  new MutationObserver(queue).observe(section,{subtree:true,childList:true,attributes:true,attributeFilter:['value']});
  queue();
 });
})();
